module.exports = __webpack_public_path__ + "img/yihuihua.9d062c63.jpg";